import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromWidgetColumns from './reducers/widget-columns.reducer';
import { EffectsModule } from '@ngrx/effects';
import { WidgetColumnsEffects } from './effects/widget-columns.effects';
import { WidgetColumnsHttpService } from '@feature/widget-columns/services/widget-columns-http.service';
import { WidgetColumnsFacadeService } from '@feature/widget-columns/services/widget-columns-facade.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromWidgetColumns.widgetColumnsFeatureKey, fromWidgetColumns.reducer),
    EffectsModule.forFeature([WidgetColumnsEffects])
  ],
  providers: [
    WidgetColumnsHttpService,
    WidgetColumnsFacadeService
  ]
})
export class WidgetColumnsModule { }
